<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  @if (loadedData || isStoreView) {

    <div class="stats-grid">

      <div class="stat-box" (click)="goToSection($event, 'delivery-notes')">
        <span class="stat-number">{{ widgetData.deliveryNotes }}</span>
        <span class="stat-label">{{ 'WIDGETS.DOCUMENTS_REVIEW.DELIVERY_NOTES' | translate }}</span>
      </div>

      <div class="stat-box" (click)="goToSection($event, 'expenses')">
        <span class="stat-number">{{ widgetData.expenses }}</span>
        <span class="stat-label">{{ 'WIDGETS.DOCUMENTS_REVIEW.EXPENSES' | translate }}</span>
      </div>

      <div class="stat-box" (click)="goToSection($event, 'payrolls')">
        <span class="stat-number">{{ widgetData.payrolls }}</span>
        <span class="stat-label">{{ 'WIDGETS.DOCUMENTS_REVIEW.PAYROLLS' | translate }}</span>
      </div>

      <div class="stat-box" (click)="goToSection($event, 'unclassified')">
        <span class="stat-number">{{ widgetData.unclassified }}</span>
        <span class="stat-label">{{ 'WIDGETS.DOCUMENTS_REVIEW.OTHER' | translate }}</span>
      </div>

    </div>

  } @else {

    <ion-skeleton-text style="height: 60px" [animated]="true"></ion-skeleton-text>

  }

</app-widget-home-core>
